/* Ланчер-навигация без перезагрузки (хендоф 2026-07-28, §Interactions/Loading).
 *
 * Клик по чипу (ланчер/категория) = та же НАВИГАЦИЯ (URL меняется,
 * back/forward работают), но грид и заголовок подменяются fetch-свопом:
 * бар остаётся смонтированным → ноль прыжков/вспышек («фильтр прыгает
 * на пару мм» — баг 2026-07-28), скролл не сбрасывается.
 * Грид на время загрузки: opacity .5 + pointer-events none (хендоф).
 * Без JS всё работает обычными ссылками (прогрессивное улучшение).
 */
(() => {
  const BAR_SELECTOR = '.pz-launcher';
  // подменяемые секции шаблона коллекции: заголовок (h1/описание) + грид
  const SWAP_SELECTORS = [
    '.shopify-section[id$="__section"]',
    '.shopify-section[id$="__main"]',
  ];
  const LOADING_CLASS = 'pz-launcher-loading';

  const isPlainLeftClick = (event) =>
    event.button === 0 && !event.metaKey && !event.ctrlKey
    && !event.shiftKey && !event.altKey;

  const findChipLink = (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !link.closest(BAR_SELECTOR)) return null;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return null;
    return url;
  };

  const setActiveChip = (url) => {
    document.querySelectorAll(BAR_SELECTOR + ' a[href]').forEach((a) => {
      const isActive = new URL(a.href, location.href).pathname === url.pathname;
      a.classList.toggle('pz-launcher__item--active',
        isActive && a.classList.contains('pz-launcher__item'));
      a.classList.toggle('pz-launcher__category--active',
        isActive && a.classList.contains('pz-launcher__category'));
      if (isActive) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  };

  const swapSections = (newDocument) => {
    SWAP_SELECTORS.forEach((selector) => {
      const current = document.querySelector(selector);
      const next = newDocument.querySelector(selector);
      if (current && next) current.replaceWith(next);
    });
    document.title = newDocument.title;
  };

  let controller = null;
  const navigate = async (url, pushState) => {
    controller?.abort();
    controller = new AbortController();
    document.body.classList.add(LOADING_CLASS);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const newDocument = new DOMParser().parseFromString(html, 'text/html');
      swapSections(newDocument);
      setActiveChip(url);
      if (pushState) history.pushState({ pzLauncher: true }, '', url);
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url); // фолбэк: обычная навигация
    } finally {
      document.body.classList.remove(LOADING_CLASS);
    }
  };

  document.addEventListener('click', (event) => {
    if (!isPlainLeftClick(event)) return;
    const url = findChipLink(event);
    if (!url) return;
    event.preventDefault();
    navigate(url, true);
  });

  window.addEventListener('popstate', (event) => {
    // back/forward после свопов: честная перезагрузка = корректное состояние
    if (event.state && event.state.pzLauncher) location.reload();
  });
})();
